import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Select, MenuItem } from "@mui/material";
import SearchBar from "../../../components/searchBar/searchBar";
import { getAllSalePoint } from "../../../services/utilsSalePoint";
import { getPresalesOfOrganization } from "../../../services/utilsPresale/utilsPresale";
import "./PreOrderHome.scss";
import {
  getAllProductReservedInventory,
} from "../../../services/utilsProductInventory";
import { convertUTCtoLocalTimeString } from "../../../components/timezonefuncions";
import { Link } from "react-router-dom";
import ActionIcon from "../../../assets/icons/actions.svg";
import CustomTable, {
  convertToTextField,
} from "../../../components/Table/Table";
import MoveProductModal from "../../../components/supervisor/MoveProductModal/MoveProductModal";
import LinearProgress from '@mui/material/LinearProgress';
import InternetErrorComponent from "../../../components/Errors/InternetErrorComponent";
import CustomTab from "../../../components/CustomTab/CustomTab";
import PresaleDetailModal from "./PresaleDetailModal";


const PreOrderHome = () => {

  //-----------------------------------------------
  //---------- INITIAL STATES --------------------
  //-----------------------------------------------

  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [displayDate, setDisplayDate] = useState("Today");
  const [selectedOption, setSelectedOption] = useState("");
  const [rawProductsData, setRawProductsData] = useState([]);
  const [tableRows, setTableRows] = useState([]);
  const [selectedSalePoint, setSelectedSalePoint] = useState("todos");
  const [selectedSalePointIds, setSelectedSalePointIds] = useState([]);
  const [salePoints, setSalePoints] = useState([]);
  const [linealLoading, setLinealLoading] = useState(false);
  const [linealLoadingError, setLinealLoadingError] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showMoveButton, setShowMoveButton] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedModalSalePoint, setSelectedModalSalePoint] = useState('');
  const [modalQuantity, setModalQuantity] = useState("");
  const [quantity, setQuantity] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productName, setProductName] = useState("");
  const [salePointName, setSalePointName] = useState("");
  const [presales, setPresales] = useState([]);
  const [presalesLoading, setPresalesLoading] = useState(false);
  const [selectedPresale, setSelectedPresale] = useState(null);

  //-----------------------------------------------
  //---------- EFFECTS ----------------------------
  //-----------------------------------------------

  useEffect(() => {
    fetchSalePoints();
  }, []);

  useEffect(() => {
    const salePointId = selectedSalePoint !== "todos" ? selectedSalePoint : null;
    setPresalesLoading(true);
    getPresalesOfOrganization(selectedDate, salePointId)
      .then((response) => setPresales(Array.isArray(response) ? response : []))
      .catch((error) => console.error("Error fetching presales:", error))
      .finally(() => setPresalesLoading(false));
  }, [selectedDate, selectedSalePoint]);

  // Effect to fetch product inventory data when sale point selection changes
  useEffect(() => {
  }, [showMoveButton]);

  // Effect to fetch product inventory data when sale point selection changes

  useEffect(() => {
    const fetchData = async () => {
      if (selectedSalePoint === "todos" && !salePoints.length) return;
  
      try {
        setLinealLoading(true);
        setLinealLoadingError(false);
  
        let response;
  
        if (selectedSalePoint === "todos") {
          response = await getAllProductReservedInventory(null, selectedDate);
          setRawProductsData(response.products);
        } else {
          response = await getAllProductReservedInventory(selectedSalePointIds[0], selectedDate);
          const salePointName = salePoints.find(sp => sp.value === selectedSalePointIds[0])?.label || "Unknown";
  
          const productsWithSalePoint = response.products.map(product => ({
            ...product,
            fk_sale_point: selectedSalePointIds[0],
            sale_point_name: salePointName
          }));
  
          setRawProductsData(productsWithSalePoint);
        }
  
        setLinealLoading(false);
      } catch (error) {
        console.error("Error fetching inventory data:", error);
        setLinealLoadingError(true);
        setLinealLoading(false);
      }
    };
  
    fetchData();
  }, [selectedSalePointIds, selectedSalePoint, selectedDate]);
  

  useEffect(() => {
    if (selectedSalePoint === "todos" && salePoints.length > 0) {
      const initialSelectedValues = salePoints.map((point) => point.value);
      setSelectedSalePointIds(initialSelectedValues);
      localStorage.setItem("fk_sale_point", JSON.stringify(initialSelectedValues));
    }
  }, [salePoints]); 


  useEffect(() => {
    if (!selectedSalePoint) {
      setTableRows([]);
      setProductName("");
      setSalePointName("");
      return;
    }
  
    const filteredProducts = rawProductsData.filter(product => {
      const productDateObj = new Date(product.reservation_date);

      if (isNaN(productDateObj.getTime())) {
        return false;
  }
      const productDate = new Date(product.reservation_date).toISOString().split('T')[0];
      return productDate === selectedDate;
    });
  
    if (filteredProducts.length > 0) {
      setProductName(filteredProducts[0].name);
      setSalePointName(filteredProducts[0].sale_point_name);
    } else {
      setProductName("");
      setSalePointName("");
    }
  
    const dataReady = filteredProducts.map((product) => {
      let rowData;
  
      switch (selectedSalePoint) {
        case "todos":
          const salePointName = salePoints.find(
            sp => sp.value === product.fk_sale_point
          )?.label || 'Unknown';
  
          rowData = createRowForallSalePoints(
            product.image,
            product.name,
            product.sku,
            product.quantity,
            product.reservation_date,
            product.fk_product,
            product.sale_point_name
          );
          break;
  
        default:
          rowData = createRowForSalePoint(
            product.image,
            product.name,
            product.sku,
            product.quantity,
            product.reservation_date,
            product.fk_product,
            selectedSalePoint
          );
          break;
      }
      return rowData;
    });
  
    setTableRows(dataReady);
  }, [selectedSalePoint, rawProductsData, selectedDate]);
  
  
  

  //-----------------------------------------------
  //---------- EVENT HANDLERS --------------------
  //-----------------------------------------------

  // Handle changes in the selected date
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    if (newDate === selectedDate) {
      setDisplayDate("Today");
    } else {
      setDisplayDate(newDate);
    }
  };

  // Handle the selection of a sale point
  const handleSelectedSalePoint = async (e) => {
    const value = e.target.value;
    setSelectedSalePoint(value);

    let selectedValues;
    if (value === "todos") {
      selectedValues = null;
    } else {
      selectedValues = [value];
    }

    setSelectedSalePointIds(selectedValues);
    await localStorage.setItem("fk_sale_point", JSON.stringify(selectedValues));

  };

  // Handle the selection of a sale point for modal
  const handleSelectedModalSalePoint = async (e) => {
    const value = e.target.value;
    setSelectedModalSalePoint(value);
  };

  const handleShowMoveButton = (id) => {
    setShowMoveButton((prev) => (prev === id ? null : id));
  };

  const handleTextSearch = (event) => {
    setSearchQuery(event);
  };

  //-----------------------------------------------
  //---------- HELPER FUNCTIONS ------------------
  //-----------------------------------------------

  // Filter the rows based on the user's search query
  const filterData = (rows) => {
    const lowercasedQuery = searchQuery.toLowerCase();
    const filtered = rows.filter(
      (row) =>
        row.name.toLowerCase().includes(lowercasedQuery) ||
        (row.sku && row.sku.toLowerCase().includes(lowercasedQuery))
    );
    return filtered;
  };

  

  //-----------------------------------------------
  //---------- DATA FETCHING FUNCTIONS -----------
  //-----------------------------------------------

  // Function to fetch current inventory for a selected sale point
  const fetchProductCurrentInventory = async (salePointId) => {
    try {
      setLinealLoading(true);
      const response = await getAllProductReservedInventory(salePointId);

      setRawProductsData(response.products);
      const newTableRows = response.products.map((product) =>
        createRowForSalePoint(
          product.image,
          product.name,
          product.sku,
          product.quantity,
          product.reservation_date,
          product.fk_product
        )
      );
      setTableRows(newTableRows);
      setLinealLoading(false);
    } catch (error) {
      console.error("Error fetching product current inventory:", error);
      setLinealLoadingError(true);
    }
  };

  // Function to fetch sale points from the backend
  const fetchSalePoints = async () => {
    try {
      const fkOrganization = localStorage.getItem("fk_organization");
      setLinealLoading(true);
      const response = await getAllSalePoint(fkOrganization);
      const formattedSalePoints = response.sale_points.map((point) => ({
        label: point.name,
        value: point.id,
      }));

      setSalePoints(formattedSalePoints);
      setLinealLoading(false);
    } catch (error) {
      console.error("Error fetching sale points:", error);
      setLinealLoading(false);
    }
  };

  //-----------------------------------------------
  //---------- TABLE MANGEMENT --------------------
  //-----------------------------------------------
  const renderSalePointTable = () => {
    let inventoryTableHeaders;

    switch (selectedSalePoint) {
      case "todos":
        inventoryTableHeaders = [
          "noHeader",
          "nameHeader",
          "skuHeader",
          "dateHeader",
          "quantityHeader",
          // "salePoint",
        ];
        break;
      default:
        if (!selectedSalePoint) {
          return null;
        }
        inventoryTableHeaders = [
          "noHeader",
          "nameHeader",
          "skuHeader",
          "dateHeader",
          "quantityHeader",
          "actionsHeader",
        ];
    }

    // verify that there are rows to show
  if (!tableRows || tableRows.length === 0) {
    return <div className="no-products-message">No hay productos reservados para la fecha seleccionada, intente con otra fecha nuevamente.</div>;
  }

  // Show table if there are rows available
    return (
      <CustomTable
        stickyHeader
        filtered={filterData}
        headers={inventoryTableHeaders}
        rows={tableRows}
        rowTypes={[[0, "image"]]}
        pagination={""}
      />
    );
  };

  //create rows for all sale points table
  const createRowForallSalePoints = (img, name, sku, currentInventory, date, id, salePointName) => {
    let currentInventoryString = currentInventory + " UND";
    // const localTimeString = convertUTCtoLocalTimeString(date);
    return {
      img,
      name,
      sku,
      // localTimeString,
      date,
      currentInventoryString,
      // salePoint: salePointName,
    };
  };

  //create rows for one sale point table
  const createRowForSalePoint = (img, name, sku, currentInventory, date, id) => {
    let currentInventoryString = currentInventory + " UND";
    //const localTimeString = convertUTCtoLocalTimeString(date);
    let formattedDate = new Date(date).toISOString().substring(0, 10);

    return {
      img,
      name,
      sku,
      // localTimeString,
      // date,
      date: formattedDate,
      currentInventoryString,
      actions: (
        <>
          <div className="flex">
            <img
              src={ActionIcon}
              alt="info"
              onClick={() => {
                setSelectedId(id);
                setSelectedProduct(name);
                setSelectedSku(sku);
                setQuantityReserved (currentInventoryString)
                setShowModal(true);
              }}
              className="table-icon"
            />
          </div>
        </>
      ),
    };
  };

  const SALE_STATUS_LABELS = {
    0: "Programada",
    1: "En preparación",
    2: "Lista para entregar",
    3: "Entregada",
    4: "Cancelada",
  };

  const createPresaleRow = (name, products, salePointName, status, transactionValue) => ({
    name,
    products,
    salePointName,
    status,
    transactionValue,
  });

  const renderPresalesTable = () => {
    if (!presales || presales.length === 0) {
      return <div className="no-products-message">No hay pre-órdenes disponibles.</div>;
    }

    const presaleRows = presales.map((p) =>
      createPresaleRow(
        p.customer?.name,
        <div>{p.products?.map((prod, i) => <div key={i}>{prod.quantity} x {prod.name}</div>)}</div>,
        p.organization?.sale_point_type?.sale_point?.name,
        SALE_STATUS_LABELS[p.sale_information?.sale_status] ?? p.sale_information?.sale_status,
        p.transaction_value != null
          ? `$ ${(p.transaction_value / 100).toLocaleString("es-CO")}`
          : ""
      )
    );

    return (
      <CustomTable
        stickyHeader
        headers={["nameHeader", "productsHeader", "salePoint", "statusHeader", "transactionValueHeader"]}
        rows={presaleRows}
        rowTypes={null}
        pagination={""}
        onRowClick={(row, index) => setSelectedPresale(presales[index])}
      />
    );
  };

  const [selectedSku, setSelectedSku] = useState(null);
  const [quantityReserved, setQuantityReserved] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");

  //-----------------------------------------------
  //-----------  UI RENDERING  --------------------
  //-----------------------------------------------

  const componentsTabs = [
    {
      navTitle: "reservationsTabLabel",
      component: (
        <>
          <section className="search-bar-container">
            <SearchBar input={searchQuery} onChange={handleTextSearch} nombre="Producto / SKU" />
          </section>
          <div className="sale-point-table-container">
            {renderSalePointTable()}
          </div>
        </>
      ),
    },
    {
      navTitle: "presalesTabLabel",
      component: (
        <div className="sale-point-table-container">
          {renderPresalesTable()}
        </div>
      ),
    },
  ];

  return (
    <main className="section-body preorden-container">
      <div className="col-12">
        <h1 className="section-title">
          <FormattedMessage id="preorderTitle" />
        </h1>
        <div className="row mt-4">
          <div className="col-3 mb-4">
            <label className="form-label">
              <FormattedMessage id="selectDate" defaultMessage="Select Date" />
            </label>
            <input
              type="date"
              id="dateInput"
              className="form-control"
              value={selectedDate}
              onChange={handleDateChange}
            />
          </div>
          <div className="col-3 mb-4">
            <label className="form-label" htmlFor="optionInput">
              <FormattedMessage id="salePointSelect" defaultMessage="Select Option" />
            </label>
            <Select
              required
              value={selectedSalePoint || ''}
              name="fk_sale_point"
              onChange={handleSelectedSalePoint}
              className="salepoint-form-select"
              id="salePointSelect"
              style={{ paddingLeft: '15px', paddingTop: '8px', display: 'flex', alignItems: 'center' }}
            >
              <MenuItem key="all" value="todos">Todos</MenuItem>
              {salePoints.map((salePoint, i) => (
                <MenuItem key={i} value={salePoint.value}>{salePoint.label}</MenuItem>
              ))}
            </Select>
          </div>
        </div>
        {(linealLoading || presalesLoading) && <LinearProgress />}
        <CustomTab props={componentsTabs} />
      </div>
      <MoveProductModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        salePointData={{
          sku: selectedSku,
          current_quantity: quantityReserved,
          sale_point_id: selectedSalePoint,
          sale_point_name: salePointName,
          selectedId: selectedId,
          selectedDate: selectedDate,
          name: selectedProduct,
        }}
        salePoints={salePoints}
        selectedModalSalePoint={selectedModalSalePoint}
        onModalSalePointChange={handleSelectedModalSalePoint}
        modalQuantity={modalQuantity}
        onQuantityChange={(e) => setModalQuantity(e.target.value)}
      />
      <PresaleDetailModal
        presale={selectedPresale}
        onClose={() => setSelectedPresale(null)}
      />
    </main>
  );
};

export default PreOrderHome;

